export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6785.f4ab4e4f.jpg";